import { Menu as OriginalMenu } from 'antd';
import styled from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

const Menu = styled(OriginalMenu)`
  color: inherit;
  border: none;

  .ant-menu-inline,
  .ant-menu-vertical,
  .ant-menu-vertical-left {
    border: none;
  }

  .ant-menu-item {
    color: ${colors.gray900};

    &:hover {
      background-color: #f7f9fe;
    }

    &-selected {
      background: ${colors.blue100};
      font-weight: 400;
    }
  }
`;

export default Menu;
